import { render, staticRenderFns } from "./RichVerticalIndicator.vue?vue&type=template&id=173837fa&scoped=true&"
import script from "./RichVerticalIndicator.vue?vue&type=script&lang=js&"
export * from "./RichVerticalIndicator.vue?vue&type=script&lang=js&"
import style0 from "./RichVerticalIndicator.vue?vue&type=style&index=0&id=173837fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173837fa",
  null
  
)

export default component.exports